import type React from 'react';
import type { ReactNode, SyntheticEvent } from 'react';
import type { OfferCardTypeEnum } from '@wwe-portal/entities/offer.type';

import type { CurrencyIconProps } from './offer-card/currency-icon';

export const DEFAULT_DRIP_DAYS = 7;

export enum OfferCardStatusEnum {
  CLAIM = 'claim',
  CLAIMED = 'claimed',
  LOCKED = 'locked',
}

export enum LayoutTypeEnum {
  BGAndItemsCentered = 'BGAndItemsCentered',
  BGTextAndItemsCentered = 'BGTextAndItemsCentered',
}

export interface OfferItem {
  itemId: string;
  defaultImageUrl?: string;
  dynamicImageUrl?: string;
  text?: string;
  description?: string;
  quantity?: number;
  percentage?: number;
  offerType?: string;
  label?: string;
  isBonusItem?: boolean;
}

export interface OfferRewardItem {
  iconElement?: React.ReactNode;
  itemId: string;
  text?: string;
  quantity?: number;
  description?: string;
}

export interface OfferCardProps {
  id: string;
  backgroundImage: string | undefined;
  dynamicBackgroundImage: string | undefined;
  title: string | undefined;
  strikethroughPrice: React.ReactNode;
  /*
  Price in USD
  */
  price: React.ReactNode;
  currentIconProps: CurrencyIconProps | undefined;

  endDate: Date | undefined;

  // Stocks
  showStock?: boolean;
  maxQuantity: number | undefined;
  quantity: number | undefined;
  quantityElement?: React.ReactNode;
  type: OfferCardTypeEnum;
  items:
    | Pick<
        OfferItem,
        'itemId' | 'defaultImageUrl' | 'dynamicImageUrl' | 'text'
      >[]
    | undefined;
  hasPip?: boolean;
  badgeIcon?: string;
  badgeText?: string;
  hasContest?: boolean;

  style?: React.CSSProperties;
  onClick?: (e: SyntheticEvent) => void;
  onPurchaseClick?: (e: SyntheticEvent) => void;
  overlay?: React.ReactNode;
  priceNum: number | undefined;
  bonusPercent?: number;
  isBlocked?: boolean;
  soldOut?: boolean;
  totalItems?: number;
  layoutType?: LayoutTypeEnum;
  storeItemDescription?: string;
  offerDescriptionText?: string;
  isDripOffer?: boolean;
  dripDays?: number;
  dripLabels?: {
    offerEndsIn?: string;
    getTotalOf?: string;
    overDays?: string;
  };
}

export type FlagShipOffer = Omit<OfferCardProps, 'type'> & {
  description?: string;
};

export interface FlagShipCardProps {
  offer: FlagShipOffer;
  onClickPrice?: (e: SyntheticEvent) => void;
  onClick?: (e: SyntheticEvent) => void;
}

export type StepupOfferCardProps = OfferCardProps & {
  status?: OfferCardStatusEnum;
  orderId: number;
};

export interface FlagShipOfferDesktop extends FlagShipOffer {
  description: string;
}

export interface FlagshipSliderProps {
  items: FlagShipOffer[];
  onClickPrice?: (
    offerId: string,
    e: SyntheticEvent,
    context: {
      slideIndex: number;
      totalSlides: number;
    }
  ) => void;
  onClick?: (offerId: string, e: SyntheticEvent) => void;
  children?: ReactNode;
}
